import { useStore } from "../../store/store";
import { useRequiredMsgs } from "../../store/requiredMsgs";
import { sillAlum, sillBifoldAlum, sillColorAlum } from "./defaults";

function useSillAlumSelector() {
  const addToQuote = useStore((state) => state.addToQuote);
  const doorType = useStore((state) => state.quote.doorType);
  const sillColor = useStore((state) => state.quote.sillColor);
  const sillStyle = useStore((state) => state.quote.sillStyle);
  const addScreen = useStore((state) => state.quote.addScreen);

  const swingDirection = useStore((state) => state.quote.swingDirection);

  const findRequired = useRequiredMsgs((state) => state.findRequired);
  const removeRequired = useRequiredMsgs((state) => state.removeRequired);

  const isBifold = doorType?.includes("Bi-fold");

  const handleClick = (label: string) => {
    const checked = label === sillStyle;

    if (checked) {
      addToQuote({ sillStyle: "" }, "sillStyle");
    } else {
      if (isBifold) {
        let update: { [key: string]: string } = {
          sillStyle: label,
        };
        if (addScreen && label !== "Raised Sill") {
          update = {
            ...update,
            screenType: "",
            addScreen: "",
            screenColor: "",
          };
        }
        addToQuote(update);
      } else {
        addToQuote({ sillStyle: label, sillColor: sillColorAlum.label });
      }

      if (findRequired("Sill Type")) {
        removeRequired("Sill Type");
      }
    }
  };

  const handleClickColor = (label: string) => {
    const checked = label === sillColor;

    if (checked) {
      addToQuote({ sillColor: "" }, "sillColor");
    } else {
      addToQuote({ sillColor: label });
      if (findRequired("Sill Finish")) {
        removeRequired("Sill Finish");
      }
    }
  };

  const sillOptions = isBifold ? sillBifoldAlum : sillAlum;

  return {
    sillOptions,
    handleClick,
    swingDirection,
    sillStyle,
    handleClickColor,
    sillColor,
    isBifold,
  };
}

export default useSillAlumSelector;
